import React from "react";
import { useNavigate } from "react-router-dom";
import RefrigerationEquipLogForm from "./RefrigerationEquipLogForm";

const AddRefrigerationEquipLog = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/refrigeration-equip-log");
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <h2>Add Refrigeration Equip Log</h2>
      </div>

      <RefrigerationEquipLogForm
        mode="add"
        isStandalone={true}
        onSaveSuccess={handleSuccess}
      />
    </>
  );
};

export default AddRefrigerationEquipLog;
